import React from "react";
import { createRoot } from "react-dom/client";
import ImageSlider from "../components/ImageSlider";

const renderImageSlider = ($, $context = $(document)) => {
	const imageSliderContainer = $context.find(".js-image-slider").toArray();

	if (!imageSliderContainer.length) return;

	imageSliderContainer.forEach((element) => {

		let props = {
			...(element && element.dataset),
		};
		const root = createRoot(element);
		root.render(<ImageSlider {...props} />);
	});
};

export default renderImageSlider;
